import { render, staticRenderFns } from "./UnitMeta.vue?vue&type=template&id=286c17e0"
import script from "./UnitMeta.vue?vue&type=script&lang=js"
export * from "./UnitMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports